'use strict';
module.exports = require('../../full/symbol/to-primitive');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/features/symbol/to-primitive.js
// module id = 615
// module chunks = 13